import { useNavigate } from 'react-router-dom';
import { useAtom, atom } from 'jotai';
import { getUserInfo } from '../../api/api';
import { useLocation } from 'react-router-dom';
import { userInfoAtom } from '../../atom';
import { Amplify, Auth } from 'aws-amplify';
import awsExportsPB from '../../aws-exports_PB';

Amplify.configure(awsExportsPB)

const errMsgAtom = atom("");
const firstLoginAtom = atom(true);

function MainComponent({ handleLoading }) {

    document.title = "NEC Partner's Bridge| ファーストコンタクトセンター";
    const location = useLocation();
    const [, setUserInfo] = useAtom(userInfoAtom);
    const [errMsg, setErrMsg] = useAtom(errMsgAtom);
    const [isFirstLogin, setIsFirstLogin] = useAtom(firstLoginAtom);
    const navigate = useNavigate();
    const param = new URLSearchParams(location.search);

    function initInput() {
        // setUserId("");
        setErrMsg("");
    }

    const login = async () => {
        const nameCheck = ["", undefined, null, false];
        handleLoading(true);
        const pu = param.get("pu");
        const token = param.get("token");
        var userId;
        localStorage.removeItem('userId');
        localStorage.removeItem('sfUserId');
        localStorage.removeItem('email');
        localStorage.removeItem("productionLists");
        localStorage.removeItem("userInfoStorage");
        localStorage.removeItem("agreement");
        if (pu === null || token === null) {
            navigate("/fcc_login");
            handleLoading(false);
            return;
        }
        try {
            const signInResult = await Auth.signIn(pu, "");
            if (signInResult.challengeName === "CUSTOM_CHALLENGE") {
                await Auth.sendCustomChallengeAnswer(
                    signInResult,
                    token
                );
                const currentUserInfo = await Auth.currentUserInfo();
                const email = currentUserInfo.attributes.email.toLowerCase();
                const pbId = currentUserInfo.attributes.name;
                if (!nameCheck.includes(email) && !nameCheck.includes(pbId)) {
                    userId = pbId + email;
                    localStorage.setItem('userId', userId);
                    localStorage.setItem('sfUserId', userId);
                    localStorage.setItem('email', email);
                } else {
                    navigate("/fcc_login");
                    handleLoading(false);
                    return;
                }
            }
        } catch (e) {
            navigate("/fcc_login");
            handleLoading(false);
            return;
        }
        const userInfo = await getUserInfo();
        if (!userInfo) {
            navigate("/fcc_login");
            handleLoading(false);
            return;
        }
        handleLoading(false);
        localStorage.setItem("agreement", userInfo.agreeFlg);
        if (userInfo.agreeFlg !== 1) {
            initInput();
            navigate("/personal_information", { state: { page: true } });
            return;
        }
        const userInforStorage = {
            sei: userInfo.sei.trim(),
            mei: userInfo.mei.trim(),
            seiYomi: userInfo.seiYomi.trim(),
            meiYomi: userInfo.meiYomi.trim(),
            departmentName: userInfo.departmentName.trim(),
            telNo: userInfo.telNo.trim()
        }
        localStorage.setItem("userInfoStorage", JSON.stringify(userInforStorage));
        if (nameCheck.includes(userInfo.sei.trim())
            || nameCheck.includes(userInfo.mei.trim())
            || nameCheck.includes(userInfo.seiYomi.trim())
            || nameCheck.includes(userInfo.meiYomi.trim())
            || nameCheck.includes(userInfo.departmentName.trim())
            || nameCheck.includes(userInfo.telNo.trim())
        ) {
            // 漢字名入力画面に遷移する
            initInput();
            navigate("/input_kanji_name", { state: { page: true } });
            return;
        }
        const userName = `${userInfo.sei} ${userInfo.mei}`;
        // const userId = localStorage.getItem('userId');
        const user = {
            userId: userId,
            userName: userName,
        };
        setUserInfo(user);
        handleLoading(false);
        initInput();
        navigate("/inquiry_status", { state: { pageSubmit: false } });
    }

    try {
        if (isFirstLogin === true) {
            login();
        } else {
            setIsFirstLogin(false);
        }
        setIsFirstLogin(false);
    } catch (err) {
        setIsFirstLogin(false);
        return false;
    }

    return (
        <div>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">NEC Partner's Bridge</h1>
                            <span className="sub of-top">ログイン</span>
                        </div>
                    </div>
                    <div className="str-outer">
                        <div className="str-inner">
                            <div>{errMsg}</div>
                            <div className="mod-tbl-form mb-30">
                            </div>
                            <div className="mod-btn of-no-arrow">

                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}


export default MainComponent;